import React from 'react'
import Header from './Components/Header/Header'
import { BrowserRouter, Routes,Route } from 'react-router-dom'
import Home from './Components/Home'
import Footer from './Components/Footer/Footer'
import ScrollTop from './Components/ScrollTop'

export default function App() {
  return (
    <>
    <BrowserRouter>
    <Header/>
    <ScrollTop>
    <Routes>
    <Route path='/' element={<Home/>}/> 
    </Routes>
    </ScrollTop>
    <Footer/>
    </BrowserRouter>
    </>
  )
}
